import Footer from "./Footer";
import oceanImage from "../images/Images Webp/tinywow_0F9A0082_59943296.webp";
import wissah from "../images/Images Webp/wissa.webp";
import seif from "../images/Images Webp/seif ben othmane.webp";
import slim from "../images/Images Webp/slim khaled.webp";
import khardeni from "../images/Images Webp/Khardeni.webp";
import wedding1 from "../images/Images Webp/tinywow_img_man_with_pen_signs_document_60034854.webp";
import wedding2 from "../images/Images Webp/aboutus_img.webp";
import wedding3 from "../images/Images Webp/tinywow_img_family_therapy_60034854.webp";
import image1 from "../images/Images Webp/tinywow_1_59945122.webp";
import { useTranslation } from "react-i18next";

const people = [
  {
    name: "Elyes Kabous",
    role: "CTO",
    imageUrl: wissah,
    xUrl: "https://www.linkedin.com/in/elyes-kabous/",
    linkedinUrl: "https://www.linkedin.com/in/elyes-kabous/",
  },
  {
    name: "Slim Khaled",
    role: "CEO",
    imageUrl: slim,
    xUrl: "#",
    linkedinUrl: "https://www.linkedin.com/in/slim-khaled-886914196/",
  },
  {
    name: "Saif ben othmane",
    role: "REALISATEUR",
    imageUrl: seif,
    xUrl: "#",
    linkedinUrl: "https://www.linkedin.com/in/seif-ben-othmen-1247711b2/",
  },
  {
    name: "Achref Khardeni",
    role: "Internship/Developper",
    imageUrl: khardeni,
    xUrl: "#",
    linkedinUrl: "https://www.linkedin.com/in/khardeni-achref/",
  },
];

export default function AboutUs() {
  const { t } = useTranslation();
  return (
    <div className="bg-white">
      <main className="isolate">
        {/* Hero section */}
        <div className="relative isolate -z-10">
          <svg
            className="absolute inset-x-0 top-0 -z-10 h-[64rem] w-full stroke-gray-200 [mask-image:radial-gradient(32rem_32rem_at_center,white,transparent)]"
            aria-hidden="true"
          >
            <defs>
              <pattern
                id="1f932ae7-37de-4c0a-a8b0-a6e3b4d44b84"
                width={200}
                height={200}
                x="50%"
                y={-1}
                patternUnits="userSpaceOnUse"
              >
                <path d="M.5 200V.5H200" fill="none" />
              </pattern>
            </defs>
            <svg x="50%" y={-1} className="overflow-visible fill-gray-50">
              <path
                d="M-200 0h201v201h-201Z M600 0h201v201h-201Z M-400 600h201v201h-201Z M200 800h201v201h-201Z"
                strokeWidth={0}
              />
            </svg>
            <rect
              width="100%"
              height="100%"
              strokeWidth={0}
              fill="url(#1f932ae7-37de-4c0a-a8b0-a6e3b4d44b84)"
            />
          </svg>
          <div
            className="absolute left-1/2 right-0 top-0 -z-10 -ml-24 transform-gpu overflow-hidden blur-3xl lg:ml-24 xl:ml-48"
            aria-hidden="true"
          >
            <div
              className="aspect-[801/1036] w-[50.0625rem] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30"
              style={{
                clipPath:
                  "polygon(63.1% 29.5%, 100% 17.1%, 76.6% 3%, 48.4% 0%, 44.6% 4.7%, 54.5% 25.3%, 59.8% 49%, 55.2% 57.8%, 44.4% 57.2%, 27.8% 47.9%, 35.1% 81.5%, 0% 97.7%, 39.2% 100%, 35.2% 81.4%, 97.2% 52.8%, 63.1% 29.5%)",
              }}
            />
          </div>
          <div className="overflow-hidden">
            <div className="mx-auto max-w-7xl px-6 pb-32 pt-36 sm:pt-60 lg:px-8 lg:pt-32">
              <div className="mx-auto max-w-2xl gap-x-14 lg:mx-0 lg:flex lg:max-w-none lg:items-center">
                <div className="w-full max-w-xl lg:shrink-0 xl:max-w-2xl">
                  <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">
                    {t("What makes us different?")}
                  </h1>
                  <p className="relative mt-6 text-lg leading-8 text-gray-600 sm:max-w-md lg:max-w-none">
                    {t(
                      "We work with couples, not just individuals. We understand that marriage is a two-person project, and we take into account the needs and goals of each spouse. We provide you with the tools and knowledge you need to make your marriage a success, from preparing legal formalities to living together."
                    )}
                  </p>
                </div>
                <div className="ml-auto ">
                  <div className="relative">
                    <img
                      src={image1}
                      alt=""
                      className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                    />
                    <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*background image*/}
        <section
          className="relative flex flex-col justify-center px-1 text-center text-white text-[200px] max-md:text-4xl"
          style={{
            backgroundImage: `url(${oceanImage})`,
            height: "700px",
            backgroundAttachment: "fixed",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        >
          <div className="relative flex flex-col justify-center min-h-full max-md:max-w-full max-md:text-4xl">
            <h1 className="relative justify-center items-center w-full h-full flex bg-black bg-opacity-50 max-md:px-5 max-md:pt-10 max-md:max-w-full max-md:text-4xl">
              HAYYA
            </h1>
          </div>
        </section>
        <div>
          {/* Main Section */}
          <div className="overflow-hidden bg-white px-6 py-16 lg:px-8 xl:py-36">
            <div className="mx-auto max-w-max lg:max-w-7xl">
              <div className="relative z-10 mb-8 md:mb-2 md:px-6">
                <div className="text-center mb-12">
                  <h2 className="text-lg font-light text-gray-500">
                    {t("More About Us")}{" "}
                  </h2>
                  <p className="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">
                    {t("what we belive")}
                  </p>
                </div>
              </div>
              <div className="relative">
                <svg
                  className="absolute right-0 top-0 -mr-20 -mt-20 hidden md:block md:[overflow-anchor:none]"
                  width={404}
                  height={384}
                  fill="none"
                  viewBox="0 0 404 384"
                  aria-hidden="true"
                >
                  <defs>
                    <pattern
                      id="95e8f2de-6d30-4b7e-8159-f791729db21b"
                      x={0}
                      y={0}
                      width={20}
                      height={20}
                      patternUnits="userSpaceOnUse"
                    >
                      <rect
                        x={0}
                        y={0}
                        width={4}
                        height={4}
                        className="text-gray-200"
                        fill="currentColor"
                      />
                    </pattern>
                  </defs>
                  <rect
                    width={404}
                    height={384}
                    fill="url(#95e8f2de-6d30-4b7e-8159-f791729db21b)"
                  />
                </svg>
                <svg
                  className="absolute bottom-0 left-0 -mb-20 -ml-20 hidden md:block md:[overflow-anchor:none]"
                  width={404}
                  height={384}
                  fill="none"
                  viewBox="0 0 404 384"
                  aria-hidden="true"
                >
                  <defs>
                    <pattern
                      id="7a00fe67-0343-4a3c-8e81-c145097a3ce0"
                      x={0}
                      y={0}
                      width={20}
                      height={20}
                      patternUnits="userSpaceOnUse"
                    >
                      <rect
                        x={0}
                        y={0}
                        width={4}
                        height={4}
                        className="text-gray-200"
                        fill="currentColor"
                      />
                    </pattern>
                  </defs>
                  <rect
                    width={404}
                    height={384}
                    fill="url(#7a00fe67-0343-4a3c-8e81-c145097a3ce0)"
                  />
                </svg>
                <div className="relative md:bg-white md:p-6">
                  <div className="lg:grid lg:grid-cols-2 lg:gap-6">
                    <div className="prose prose-lg prose-indigo text-gray-500 lg:max-w-none">
                      <h3> {t("Our Philosophy")} </h3>
                      <p>
                        Chez Hayya, nous croyons que chaque couple mérite des
                        noces qui reflètent leur histoire d&apos;amour unique,
                        indépendamment de leur origine ou de leur situation
                        financière. Notre philosophie repose sur trois principes
                        fondamentaux : l&apos;éducation gratuite, l&apos;inclusivité et la
                        stabilité financière.
                      </p>
                      <p>
                        Éducation gratuite : Nous autonomisons les couples en
                        leur fournissant les connaissances nécessaires pour
                        planifier leurs noces de rêve grâce à des ateliers
                        accessibles et des ressources en ligne, favorisant ainsi
                        la confiance et la créativité. Inclusivité : Nous
                        célébrons l&apos;amour sous toutes ses formes et accueillons
                        tous les couples et professionnels du mariage, en
                        veillant à ce que chacun se sente représenté et
                        valorisé. Nos partenariats avec des fournisseurs
                        diversifiés nous permettent de répondre aux différentes
                        traditions culturelles et préférences personnelles.
                      </p>
                      <p>
                        Stabilité financière : Reconnaissant que les noces
                        peuvent représenter un investissement financier
                        important, nous accordons la priorité à la transparence
                        et à une planification budgétaire responsable. Nous
                        travaillons avec les couples pour créer des forfaits sur
                        mesure alignés sur leurs objectifs financiers, leur
                        permettant ainsi de profiter de leur journée spéciale
                        sans s&apos;endetter de manière excessive. Chez Hayya, notre
                        but est de permettre à chacun de célébrer les moments
                        qui font de nous ce que nous sommes. Notre vision est
                        d&apos;autonomiser les individus du monde entier pour qu&apos;ils
                        créent des célébrations authentiques qui reflètent ce
                        qui compte le plus pour eux. Rejoignez-nous dans une
                        communauté dynamique où l&apos;amour ne connaît pas de
                        limites.
                      </p>
                    </div>
                    <div className="prose prose-lg prose-indigo mt-6 text-gray-500 lg:mt-0">
                      <h3>{t("Our Community")}</h3>
                      <p>
                        Notre but est de permettre à chacun de célébrer les
                        moments qui font de nous ce que nous sommes. Nous
                        croyons que chaque histoire d&apos;amour mérite
                        d&apos;être honorée, et nous sommes déterminés à fournir
                        les outils et les ressources nécessaires aux couples
                        pour créer leurs célébrations uniques.
                      </p>
                      <p>
                        Notre vision est d&apos;autonomiser les individus à
                        travers le monde pour qu&apos;ils puissent concevoir des
                        célébrations qui leur sont authentiques, reflétant les
                        moments qui comptent le plus. Nous nous efforçons de
                        créer un environnement inclusif où tous les couples et
                        professionnels du mariage se sentent les bienvenus,
                        garantissant que l&apos;amour soit célébré sous toutes
                        ses formes.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Card section */}
        <div className="flex flex-col items-center min-h-screen bg-gray-900 py-16">
          <div className="text-center mb-12">
            <h2 className="text-lg font-light text-white">
              {t("Our Expertise")}
            </h2>
            <h1 className="text-4xl font-bold tracking-tight text-white sm:text-6xl">
              {t("PRENUPTIAL AGREEMENTS.")}
            </h1>
          </div>
          <div className="flex flex-col md:flex-row justify-center w-full max-w-7xl space-y-6 md:space-y-0 md:space-x-12 px-4">
            {[
              {
                title: t("Prenuptial Agreements"),
                description: t(
                  "A prenuptial agreement is a legal contract that couples sign before marriage, outlining the division of assets in case of divorce. It serves to protect individual property and clarify financial rights and responsibilities."
                ),
                imageUrl: wedding1,
              },
              {
                title: t("Wedding Planning"),
                description: t(
                  "Wedding planning involves organizing and coordinating all the details of a couple's big day, from selecting a venue to finalizing the guest list. It encompasses everything from choosing the perfect dress to arranging the catering and entertainment."
                ),
                imageUrl: wedding2,
              },
              {
                title: t("Relationship Guidance"),
                description: t(
                  "Relationship guidance offers advice and support to couples, helping them navigate challenges and strengthen their bond. It involves effective communication, conflict resolution, and fostering mutual respect and understanding."
                ),
                imageUrl: wedding3,
              },
            ].map((card, index) => (
              <div
                key={index}
                className="flex flex-col justify-between h-full rounded-lg bg-white shadow-lg dark:bg-surface-dark w-full md:w-[30%] p-8"
              >
                <div>
                  <h5 className="mb-4 text-xl font-semibold leading-tight text-center">
                    {card.title}
                  </h5>
                  <div className="flex justify-center">
                    <img
                      src={card.imageUrl}
                      alt={card.title}
                      className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                    />
                  </div>
                  <p className="mb-6 text-sm text-center pt-4">
                    {card.description}
                  </p>
                </div>
                <div className="flex justify-center mt-auto pt-4">
                  <button
                    type="button"
                    className="inline-block rounded-md bg-pink-600 px-6 py-2.5 text-sm font-medium uppercase leading-normal text-white shadow-md transition duration-150 ease-in-out hover:bg-pink-500 focus:bg-gray-400 focus:shadow-md focus:outline-none focus:ring-0 active:bg-gray-500 active:shadow-md"
                  >
                    {t("Read More")}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white py-20">
          <div className="mx-auto max-w-7xl px-6 text-center lg:px-8">
            <div className="mx-auto max-w-2xl">
              <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                {t("Meet our team")}
              </h2>
              <p className="mt-4 text-lg leading-8 text-gray-600">
                {t(
                  "We’re a dynamic group of individuals who are passionate about what we do."
                )}
              </p>
            </div>
            <ul
              role="list"
              className="mx-auto mt-20 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3"
            >
              {people.map((person) => (
                <li key={person.name}>
                  <img
                    className="mx-auto h-56 w-56 rounded-full"
                    src={person.imageUrl}
                    alt=""
                  />{" "}
                  {/* Use person.imageUrl here */}
                  <h3 className="mt-6 text-base font-semibold leading-7 tracking-tight text-gray-900">
                    {person.name}
                  </h3>
                  <p className="text-sm leading-6 text-gray-600">
                    {person.role}
                  </p>
                  <ul role="list" className="mt-6 flex justify-center gap-x-6">
                    <li>
                      <a
                        href={person.xUrl}
                        className="text-gray-400 hover:text-gray-500"
                      >
                        <span className="sr-only">X</span>
                        <svg
                          className="h-5 w-5"
                          aria-hidden="true"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path d="M11.4678 8.77491L17.2961 2H15.915L10.8543 7.88256L6.81232 2H2.15039L8.26263 10.8955L2.15039 18H3.53159L8.87581 11.7878L13.1444 18H17.8063L11.4675 8.77491H11.4678ZM9.57608 10.9738L8.95678 10.0881L4.02925 3.03974H6.15068L10.1273 8.72795L10.7466 9.61374L15.9156 17.0075H13.7942L9.57608 10.9742V10.9738Z" />
                        </svg>
                      </a>
                    </li>
                    <li>
                      <a
                        href={person.linkedinUrl}
                        className="text-gray-400 hover:text-gray-500"
                      >
                        <span className="sr-only">LinkedIn</span>
                        <svg
                          className="h-5 w-5"
                          aria-hidden="true"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.298v15.403C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.298C19 1.581 18.402 1 17.668 1z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </a>
                    </li>
                  </ul>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </main>
      <Footer></Footer>
    </div>
  );
}
